/**
 * @fileoverview Height constants and configuration for gantt container
 * @module HeightConstants
 */

export const HEIGHTS = Object.freeze({
  DEFAULT: 'calc(100vh - 214px)',
  WITH_BAB: 'calc(100vh - 228px)',
  WITH_ACTIVITY_CARD: 'calc(100vh - 526px)',
  WITH_BOTH: 'calc(100vh - 540px)'
});

export const CONFIG = Object.freeze({
  DEBOUNCE_DELAY: 16, // ~60fps
  MUTATION_OBSERVER_OPTIONS: {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style'],
    attributeOldValue: false
  }
});
